import React from "react"
import { Box, BoxProps, Stack } from "@chakra-ui/core"
import { useForm } from "react-hook-form"
import TextField from "../FormFields/TextField"
import StarsInput from "../StarsInput"
import TextAreaField from "../FormFields/TextAreaField"
import { Button } from "../Buttons"
import { postJudgemeReview } from "../../api/reviews"
import Body from "../typography/Body"
import config from "../../config"

type ReviewFormProps = BoxProps & {
  productId: number
}

type FormValues = {
  name: string
  email: string
  rating: number
  title: string
  body: string
}

export default function ReviewForm({ productId, ...props }: ReviewFormProps) {
  const { register, handleSubmit } = useForm<FormValues>()
  const [isLoading, setIsLoading] = React.useState(false)
  const [success, setSuccess] = React.useState(false)

  const onSubmit = async (data: FormValues) => {
    setIsLoading(true)
    try {
      await postJudgemeReview({
        ...data,
        platform: "shopify",
        url: config.GATSBY_SHOPIFY_SHOP_DOMAIN,
        id: productId,
      })
      setSuccess(true)
    } catch (error) {
      console.error(error)
    }
    setIsLoading(false)
  }

  return !success ? (
    <Box as="form" {...props} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing="0.75rem">
        <TextField
          ref={register({ required: true })}
          placeholder="Name"
          name="name"
        />
        <TextField
          ref={register({ required: true })}
          placeholder="Email"
          name="email"
        />
        <StarsInput
          ref={register({ required: true })}
          name="rating"
          defaultValue={5}
        />
        <TextField
          ref={register({ required: true })}
          placeholder="Title"
          name="title"
        />
        <TextAreaField
          ref={register({ required: true })}
          placeholder="Write your comments here"
          name="body"
        />
        <Button type="submit" isLoading={isLoading}>
          Submit review
        </Button>
      </Stack>
    </Box>
  ) : (
    <Box {...props}>
      <Body w="100%" textAlign="center">
        Thank you for your review!
      </Body>
    </Box>
  )
}
